import { useNavigate } from "react-router-dom";
import { FaQuestionCircle } from "react-icons/fa";

import Badge from "@Components/Badge";
import { useNewReleaseNotes } from "@Hooks/useNewReleaseNotes";

import styles from "./HelpCenterButton.module.scss";

const HelpCenterButton = () => {
  const navigate = useNavigate();
  const { hasNewReleaseNotes } = useNewReleaseNotes();
  const navigateToHelpCenter = () => {
    navigate("/help-center");
  };
  return (
    <>
      <button className={styles.button} onClick={navigateToHelpCenter}>
        <span className={styles.iconWrapper}>
          <FaQuestionCircle />
          {hasNewReleaseNotes && (
            <span className={styles.badgeAnchor}>
              <Badge badgeCount={1} />
            </span>
          )}
        </span>

        <div style={{ paddingLeft: 10 }}>Help Center</div>
      </button>
    </>
  );
};
export default HelpCenterButton;
